export const ACCOUNT_PAGES = {
  // Auth
  '/auth/login': 'AUTH_LOGIN',
  '/auth/register': 'AUTH_REGISTER',
  '/auth/register-complete': 'AUTH_REGISTER_COMPLETE',
  '/auth/register/complete-info': 'AUTH_REGISTER_COMPLETE_INFO',
  '/auth/forgot-password': 'AUTH_FORGOT_PASSWORD',
  '/auth/restore-password': 'AUTH_RESTORE_PASSWORD',
  '/auth/verify-email': 'AUTH_VERIFY_EMAIL',

  // ACCOUNT
  '/': 'ACCOUNT_HOME',
  '/summary': 'ACCOUNT_SUMMARY',
  '/deposits': 'ACCOUNT_DEPOSITS',
  '/my-orders': 'ACCOUNT_MY_ORDERS',
  '/my-orders/details': 'ACCOUNT_ORDER_DETAILS',
  '/my-sales': 'ACCOUNT_MY_SALES',
  '/my-sales/details': 'ACCOUNT_SALE_DETAILS',
  '/my-projects': 'ACCOUNT_MY_PROJECTS',
  '/my-projects/details': 'ACCOUNT_MY_PROJECT_DETAILS',
  '/my-projects/create': 'ACCOUNT_PROJECT_CREATE',
  '/my-projects/edit': 'ACCOUNT_PROJECT_EDIT',
  '/notifications': 'ACCOUNT_NOTIFICATIONS',
  '/messages': 'ACCOUNT_MESSAGES',
  '/offers': 'ACCOUNT_OFFERS',
  '/my-footprint': 'ACCOUNT_MY_FOOTPRINT',
  '/my-footprint/list': 'ACCOUNT_MY_FOOTPRINT_LIST',
  '/admin': 'ACCOUNT_ADMIN_HOME',
  '/admin/generate-certificate': 'ACCOUNT_ADMIN_GENERATE_CERTIFICATE',
  '/admin/massive-calculation': 'ACCOUNT_ADMIN_MASSIVE_CALCULUS',
  '/admin/brokerage': 'ACCOUNT_ADMIN_BROKERAGE',
  '/admin/validate-users': 'ACCOUNT_ADMIN_VALIDATE_USERS',
  '/admin/validate-withdrawals': 'ACCOUNT_ADMIN_VALIDATE_WITHDRAWALS',
  '/admin/validate-documents': 'ACCOUNT_ADMIN_VALIDATE_DOCUMENTS',
  '/admin/validate-transfers': 'ACCOUNT_ADMIN_VALIDATE_TRANSFER',
  '/admin/validate-deposits': 'ACCOUNT_ADMIN_VALIDATE_DEPOSITS',
  '/admin/download-invoices': 'ACCOUNT_ADMIN_DOWNLOAD_INVOICES',
  '/admin/cabify-process': 'ACCOUNT_ADMIN_CABIFY_PROCESS',
  '/admin/create-sale-offer': 'ACCOUNT_ADMIN_CREATE_SALE_OFFER',
  '/settings': 'ACCOUNT_SETTINGS_HOME',
  '/settings/personal-details': 'ACCOUNT_SETTINGS_PERSONAL_DETAILS',
  '/settings/company-details': 'ACCOUNT_SETTINGS_COMPANY_DETAILS',
  '/settings/company-files': 'ACCOUNT_SETTINGS_COMPANY_FILES',
  '/settings/user-preferences': 'ACCOUNT_SETTINGS_USER_PREFERENCES',
  '/settings/change-password': 'ACCOUNT_SETTINGS_CHANGE_PASSWORD',
  '/stock-alerts': 'ACCOUNT_STOCK_ALERTS',
  '/developers': 'ACCOUNT_DEVELOPERS_HOME',
  '/developers/integration-details': 'ACCOUNT_DEVELOPERS_INTEGRATION_DETAILS',
  '/developers/integration-projects': 'ACCOUNT_DEVELOPERS_INTEGRATION_PROJECTS',
  '/developers/integration-settings': 'ACCOUNT_DEVELOPERS_INTEGRATION_SETTINGS',
  '/developers/offset-by-excel': 'ACCOUNT_DEVELOPERS_OFFSET_BY_EXCEL',
  '/developers/my-orders/details': 'ACCOUNT_DEVELOPERS_ORDER_DETAILS',
  '/payments/error': 'ACCOUNT_PAYMENTS_ERROR',
  '/payments/paypal': 'ACCOUNT_PAYMENTS_PAYPAL',
}
